/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monthly_Plan_Early_BirdInputs */

const en_monthly_plan_early_bird = /** @type {(inputs: Monthly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly (Early Bird)`)
};

const ar_monthly_plan_early_bird = /** @type {(inputs: Monthly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شهري (الحجز المبكر)`)
};

const de_monthly_plan_early_bird = /** @type {(inputs: Monthly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatlich (Frühbucher)`)
};

const es_monthly_plan_early_bird = /** @type {(inputs: Monthly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensual (anticipado)`)
};

const fr_monthly_plan_early_bird = /** @type {(inputs: Monthly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensuel (Premiers arrivés)`)
};

const it_monthly_plan_early_bird = /** @type {(inputs: Monthly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensile (Early Bird)`)
};

const ja_monthly_plan_early_bird = /** @type {(inputs: Monthly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月間（早期割引）`)
};

const ko_monthly_plan_early_bird = /** @type {(inputs: Monthly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`월간(얼리버드)`)
};

const pt_br_monthly_plan_early_bird = /** @type {(inputs: Monthly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensal (Antecipado)`)
};

const ru_monthly_plan_early_bird = /** @type {(inputs: Monthly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежемесячно (ранняя пташка)`)
};

const th_monthly_plan_early_bird = /** @type {(inputs: Monthly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายเดือน (ก่อนเวลา)`)
};

const tr_monthly_plan_early_bird = /** @type {(inputs: Monthly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aylık (Erken Kayıt)`)
};

const zh_cn_monthly_plan_early_bird = /** @type {(inputs: Monthly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连续包月（早鸟）`)
};

const zh_tw_monthly_plan_early_bird = /** @type {(inputs: Monthly_Plan_Early_BirdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月訂閱（早鳥）`)
};

/**
* | output |
* | --- |
* | "Monthly (Early Bird)" |
*
* @param {Monthly_Plan_Early_BirdInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const monthly_plan_early_bird = /** @type {((inputs?: Monthly_Plan_Early_BirdInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monthly_Plan_Early_BirdInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_monthly_plan_early_bird(inputs)
	if (locale === "ar") return ar_monthly_plan_early_bird(inputs)
	if (locale === "de") return de_monthly_plan_early_bird(inputs)
	if (locale === "es") return es_monthly_plan_early_bird(inputs)
	if (locale === "fr") return fr_monthly_plan_early_bird(inputs)
	if (locale === "it") return it_monthly_plan_early_bird(inputs)
	if (locale === "ja") return ja_monthly_plan_early_bird(inputs)
	if (locale === "ko") return ko_monthly_plan_early_bird(inputs)
	if (locale === "pt_br") return pt_br_monthly_plan_early_bird(inputs)
	if (locale === "ru") return ru_monthly_plan_early_bird(inputs)
	if (locale === "th") return th_monthly_plan_early_bird(inputs)
	if (locale === "tr") return tr_monthly_plan_early_bird(inputs)
	if (locale === "zh_cn") return zh_cn_monthly_plan_early_bird(inputs)
	return zh_tw_monthly_plan_early_bird(inputs)
});